import styled from "styled-components";

interface IUserStatusCircleProgressGlowingBackgroundStyledProps {
    animationDurationMs?: number;
    animationType?: string;
    size: number;
}

export const UserStatusCircleProgressGlowingBackgroundStyled = styled.div<IUserStatusCircleProgressGlowingBackgroundStyledProps>`
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    opacity: 1;
    width: ${({ size }) => `${size}px`};
    height: ${({ size }) => `${size}px`};
    transition: ${({ animationDurationMs, animationType }) => `opacity ${animationDurationMs || 200}ms ${animationType || 'ease-out'}`};
    pointer-events: none;
    
    &.hidden {
        opacity: 0;
    }
`;
